import {createBrowserRouter, RouteObject} from 'react-router-dom';
import ErrorPage from "@/components/error-page";
import {showLoader} from "@/stores/ui-store";
import Preloader from "@/components/preloader";
import {lazy, Suspense} from "react";

async function lazyLogin() {
  return lazyRoute(() => import("@/features/auth/login-page"), "lazyLogin");
}

async function lazyRoute(importFunc: any, routeName?: string) {
  showLoader(true, routeName);
  const res = await importFunc();
  showLoader(false, routeName);
  return ({Component: res.default});
}

const MainLayout = lazy(() => import("@/features/core/layout/main-layout"));

export const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <Suspense fallback={<Preloader/>}>
        <MainLayout/>
      </Suspense>
    ),
    errorElement: <ErrorPage/>,
    children: [
      {
        index: true,
        lazy: () => lazyRoute(() => import("@/features/trading/trading-page"))
      },
      {
        path: "dashboard",
        lazy: () => lazyRoute(() => import("@/features/dashboard/dashboard-page"))
      },
      {
        path: "wallet",
        lazy: () => lazyRoute(() => import("@/features/wallet/wallet-page"))
      },
      {
        path: "support",
        lazy: () => lazyRoute(() => import("@/features/support/support-page"))
      },
      {
        path: "settings",
        lazy: () => lazyRoute(() => import("@/features/settings/settings-page"))
      },
      {
        path: "notifications",
        lazy: () => lazyRoute(() => import("@/features/core/notifications-page"))
      },
      {
        path: "sp-auth",
        lazy: () => lazyRoute(() => import("@/features/settings/settings-page"))
      }
    ],
  },
  {
    path: "/login",
    lazy: lazyLogin,
  },
  {
    path: "/signup",
    lazy: lazyLogin,
  },
  {
    path: "/activate-account",
    lazy: lazyLogin,
  },
  {
    path: "/reset-password",
    lazy: lazyLogin,
  },
  {
    path: "/privacy",
    lazy: () => lazyRoute(() => import("@/features/auth/privacy-page"))
  },
  {
    path: "/terms",
    lazy: () => lazyRoute(() => import("@/features/auth/terms-page"))
  },
  {
    path: 'cgx-admin/*',
    lazy: () => lazyRoute(() => import("@/admin/routes/admin-routes")),
  }
].map((r: RouteObject) => {
  if (!r.HydrateFallback) {
    r.HydrateFallback = () => <Preloader/>;
  }
  return r;
}));
if (import.meta.hot) {
  import.meta.hot.dispose(() => router.dispose());
}